import React from "react";
import { useNavigate } from "react-router-dom";
import tokens from "../theme/tokens";

const { color } = tokens;

export default function NotFoundPage() {
  const nav = useNavigate();
  return (
    <div style={{background:color.surface.base,color:color.text.primary,minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center",fontFamily:"system-ui",flexDirection:"column",gap:16}}>
      <div style={{fontSize:48}}>⚕</div>
      <div style={{fontSize:22,fontWeight:800}}>Page not found</div>
      <button style={{background:color.accent.primary,color:"#fff",border:"none",borderRadius:6,padding:"10px 20px",cursor:"pointer",fontSize:14}} onClick={()=>nav("/board")}>← Back to Board</button>
    </div>
  );
}
